import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { RegulatorDto } from '@model/RegulatorOptionDto'

interface RegulatorModalProps {
  regulator?: RegulatorDto
  visible: boolean
  onSubmit(): void
  closeModal(): void
}

export const RegulatorPopUpModal: BaseModalType<RegulatorModalProps> = (props) => {
  const { regulator, onSubmit } = props

  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{regulator?.title || ''}</Modal.Header>
      <Modal.Body>
        <Modal.Body.List>
          {regulator?.popupText?.map((p) => (
            <Modal.Body.List.Item>
              <span
                dangerouslySetInnerHTML={{
                  __html: p,
                }}
              />
            </Modal.Body.List.Item>
          ))}
        </Modal.Body.List>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={onSubmit}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
